module.exports = __webpack_public_path__ + "img/16l003-02.3c23a900.jpg";